<template>
  <div style="margin-top: 70px" class="haacf">
    <!-- banner -->
    <div class="banner">
      <div id="slideBox" class="slideBox">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in banner" :key="item.id"
          ><img :src="item"
          /></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- 箭头 -->
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>

    <!-- 赛事通知 -->
    <div class="homehot container">
      <div class="title">赛事通知</div>
      <div class="news">
        <div
          v-for="item in newsDataList"
          :key="item.id"
          @click="toinfo(item.id)"
        >
          <p
            style="
              margin: 0;
              width: 78%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            "
          >
            <img
              src="../../static/点.png"
              style="width: 27px; height: 27px"
            />{{ item.title }}
          </p>
          <span style="color: #bdbdbd">{{ item.issueTime }}</span>
        </div>
        <!-- <div><p style="margin:0"><img src="../../static/点.png" style="width: 27px;height: 27px;">不忘初心,2021春季评审圆满落幕</p><span>2012-09-18</span></div>
           <div><p style="margin:0"><img src="../../static/点.png" style="width: 27px;height: 27px;">不忘初心,2021春季评审圆满落幕</p><span>2012-09-18</span></div>
           <div><p style="margin:0"><img src="../../static/点.png" style="width: 27px;height: 27px;">不忘初心,2021春季评审圆满落幕</p><span>2012-09-18</span></div> -->
      </div>
    </div>

    <!-- 视频 -->
    <video
      :src="video"
      v-if="video"
      class="homehot container"
      style="width: 50%"
      controls
    ></video>

    <!-- 赛事介绍 -->
    <!-- <div class="matchIntroduced container">
        <div class="title">赛事介绍</div>
        <div style="border: 1px solid #ccc;
    overflow-y: scroll;padding: 15px;margin:25px 0;height:400px" v-html="dataList.matchIntroduce">

        </div>
    </div> -->

    <!-- 赛事进度 -->
    <div class="EventSchedule">
      <!-- <div v-for="item in timerShaft" :key="item.id">
            <el-tooltip content="Tsssssssssssssssssss" placement="top">
            <el-button circle> .</el-button>

            </el-tooltip>
            <div></div>
            <p>{{item.name}}</p>
        </div> -->

      <!-- <drag-comp @goNext="watchCar"/> -->
      <el-steps :active="timeactive" align-center class="container computer">
        <el-step
          :title="item.name + ' ' + '>'"
          v-for="(item, index) in timerShaft"
          :key="item.id"
        >
          <template slot="description">
            <p class="introbro">{{ item.matchTime }}</p>
            <div class="intro">
              <p style="white-space: pre-wrap" v-html="item.intro"></p>
            </div>
          </template>
        </el-step>
      </el-steps>
      <div class="wrapper">
        <el-steps
          :active="timeactive"
          align-center
          class="container"
          direction="vertical"
        >
          <el-step
            :title="item.name + '>'"
            v-for="item in timerShaft"
            :key="item.id"
            class="item"
          >
            <template slot="description">
              <p class="introbro">{{ item.matchTime }}</p>
              <div class="intro">
                <p
                  style="white-space: pre-wrap; text-align: initial"
                  v-html="item.intro"
                ></p>

                <!-- <p>{{item.intro}}</p> -->
              </div>
            </template>
          </el-step>
        </el-steps>
        <!-- <ul ref="content" class='content'>
       <el-steps :active="timeactive" align-center class="container" direction="vertical">
          <el-step :title="item.name"  v-for="item in timerShaft" :key="item.id"  class="item">
              <template slot="description">
                  <p class="introbro">{{item.matchTime}}</p>
                  <div class="intro">
                      <p v-html='item.intro'></p>


                  </div>

              </template>
          </el-step>
</el-steps>
    </ul> -->
      </div>
    </div>

    <!--  competition related  -->
    <div class="comp_related">
      <div class="title">赛事相关</div>
      <div class="container comp_related_sect">
        <ul class="borderRadius">
          <li>
            <div class="cr_l">
              <p class="cr_title cr_title1">
                <img src="../../static/组委会.png"/>大赛组委会
              </p>
              <p
                class="cr_det"
                style="white-space: pre-wrap"
                v-html="dataList.committee"
              ></p>
            </div>
            <div class="cr_r">
              <p class="cr_title cr_title2">
                <img src="../../static/人.png"/>
                <label v-show="params.domain != 'lzpcc' && params.domain != 'gszjbs'" style="font-weight: 500;">专家委员会</label>
                <label v-show="params.domain == 'gszjbs'" style="font-weight: 500;">时间及日程安排</label>

              </p>
              <p
                class="cr_det"
                style="white-space: pre-wrap"
                v-html="dataList.committeeExpert"
              ></p>
            </div>
          </li>
          <li>
            <div class="cr_l">
              <p class="cr_title cr_title3">
                <img src="../../static/联系方式.png"/>
                <label v-show="params.domain != 'lzpcc' && params.domain != 'gszjbs'" style="font-weight: 500;">大赛组委会联系方式</label>
                <label v-show="params.domain == 'gszjbs'" style="font-weight: 500;">联系方式</label>
              </p>
              <p
                class="cr_det"
                style="white-space: pre-wrap"
                v-html="dataList.committeeConnect"
              ></p>
            </div>
            <div class="cr_r">
              <p class="cr_title cr_title4">
                <img src="../../static/叹号 (1).png"/>参赛对象
              </p>
              <p
                class="cr_det"
                style="white-space: pre-wrap"
                v-html="dataList.joinObject"
              ></p>
            </div>
          </li>
          <li>
            <div class="cr_l" id="download">
              <p class="cr_title cr_title5">
                <img src="../../static/资料 (1).png"/>资料下载
              </p>
              <p class="cr_det" style="display: flex; flex-wrap: wrap">
                <a
                  v-for="item in objnews"
                  :key="item.uid"
                  @click="downName(item.url, item.name)"
                >{{ item.name }}</a
                >
                <!-- <a :href="item.url" target="_blank" class="file_down" v-for="item in objnews" :key="item.uid" @click='downName(item.url,item.name)'>{{item.name}}</a> -->

                <!-- <a href="/uploads/download/学生操作手册.pdf" target="_blank" class="file_down">学生操作手册</a>
                            <a href="/uploads/download/《职业生涯规划书》撰写要求.pdf" target="_blank" class="file_down">《职业生涯规划书》撰写要求</a>
                            <a href="/uploads/download/《职场角色模拟》VCR拍摄要求.pdf" target="_blank" class="file_down">《职场角色模拟》VCR拍摄要求</a>
                            <a href="/uploads/download/《职业世界说明书》撰写要求.pdf" target="_blank" class="file_down">《职业世界说明书》撰写要求</a> -->
              </p>
            </div>
            <div class="cr_r">
              <p class="cr_title cr_title6">
                <img src="../../static/奖项.png"/>奖项设置
              </p>
              <p
                class="cr_det"
                style="white-space: pre-wrap"
                v-html="dataList.awardSet"
              ></p>
            </div>
          </li>
        </ul>
      </div>
    </div>


    <!-- 参赛学校 -->
    <div class="ParticipatingSchools container" v-show="params.domain != 'lzpcc' && params.domain != 'gszjbs'">
      <div class="title">参赛学校</div>
      <div
        style="border: 1px solid #ccc; padding: 15px; margin: 25px 0"
        class="schoolP"
      >
        <img
          v-for="item in schoollogoImg"
          :key="item.id"
          :src="item"
          style="
            width: 100px;
            height: 100px;
            padding-right: 8px;
            padding-bottom: 8px;
          "
        />
      </div>
    </div>
    <!-- 赛事锦囊 -->
    <div
      style="width: 900px; margin: auto"
      class="sadadfc"
      v-if="videoList.length > 0"
    >
      <div class="titleasdas">赛事锦囊</div>
      <el-carousel
        :interval="0"
        type="card"
        height="312px"
        indicator-position="none"
        @change="vidPP"
        class="pc"
      >
        <el-carousel-item v-for="(item,index) in videoList" :key="index" @change="vidPP">
          <video :src="item.url" controls></video>
          <h2>{{ item.name }}</h2>
        </el-carousel-item>
      </el-carousel>
      <div class="banner pcmobile">
        <div id="slideBox" class="slideBox">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item,index) in videoList" :key="index">
              <video :src="item.url" controls></video>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- 箭头 -->
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
          </swiper>
        </div>
      </div>
      <!-- <el-carousel :interval="0"  height="312px"  indicator-position="none"  @change="vidPP" class='pcmobile'>
    <el-carousel-item  v-for="item in videoList" :key="item" @change="vidPP">
        <video :src='item.url' controls></video>
        <h2>{{item.name}}</h2>
    </el-carousel-item>
  </el-carousel> -->
    </div>

    <!-- 参赛锦囊 -->
    <!-- <div class="competingKits container" >
        <div class="title">参赛锦囊</div>
       <div>
              <swiper :options="competingKits" ref="mySwiper1">
      <swiper-slide>I'm Slide 1</swiper-slide>
      <swiper-slide>I'm Slide 2</swiper-slide>
      <swiper-slide>I'm Slide 3</swiper-slide>
      <swiper-slide>I'm Slide 4</swiper-slide>
      <swiper-slide>I'm Slide 5</swiper-slide>
      <swiper-slide>I'm Slide 6</swiper-slide>
      <swiper-slide>I'm Slide 7</swiper-slide>
      <swiper-slide>I'm Slide 8</swiper-slide>
      <swiper-slide>I'm Slide 9</swiper-slide>
      <swiper-slide>I'm Slide 10</swiper-slide>
      <swiper-slide>I'm Slide 11</swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      箭头
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
       </div>

    </div> -->

    <!--  schedule arrangement  -->
    <!-- <div class="sche_arrange">
        <div class="sect_title container tr sche_arrange_title"></div>
        <div class="container sche_arrange_sect">
            <ul>
                <li>
                    <div class="cn_top">
                        <span class="cn_year fsize18">校选赛</span>
                        <span class="cn_date">9/16-11/15</span>
                    </div>
                    <div class="cn_bot">
                        <p class="sa_explain fsize14">各高校自行组织，环节、形式不限，10月31日前参加晋级赛选手需提交《2020年吉林省“吉人梦想杯”大学生职业生涯规划大赛报名表》（附件1）至邮箱jlsghds@126.com。要求：8000人以上高校报送选手数不少于5人，其他高校报送选手不少于3人。
                            参赛选手需在10月31日前提交：①《职业生涯规划书》；②《职场角色模拟》VCR；③《职业世界说明书》三部分材料至“2020年吉林省‘吉人梦想杯’大学生职业生涯规划大赛平台”。
                        </p>
                    </div>
                </li>
                <li>
                    <div class="cn_top">
                        <span class="cn_year fsize18">晋级赛</span>
                        <span class="cn_date">11/16-11/30</span>
                    </div>
                    <div class="cn_bot">
                        <p class="sa_explain fsize14">此赛段专家根据参赛选手提交《职业生涯规划书》、《职场角色模拟》VCR、《职业世界说明书》的材料通过大赛平台进行评审打分。晋级赛选拔成绩排名前50%的选手进入省决赛。</p>

                    </div>
                </li>
                <li>
                    <div class="cn_top">
                        <span class="cn_year fsize18">省决赛</span>
                        <span class="cn_date">12/1-12/15</span>
                    </div>
                    <div class="cn_bot">
                        <p class="sa_explain fsize14">此赛段共分三个环节，分别从自我认知、外部世界探索、未来生涯规划三部分内容对选手进行考察。选手参与第一环节活动生成个人专属职业生涯报告书，获得此活动全部认证后方可晋级。第二环节通过专题展示筛选15名选手晋级第三环节。晋级省决赛选手须在决赛前提交参赛作品PPT电子版，具体事宜另行通知。
                            第一环节：“自我认知探索”生涯体验。此环节为生涯体验活动，旨在让学生通过直接参与获得体验、激发行动，从而体现生涯自助的功能，生涯体验后会生成个人专属职业生涯报告书。
                            第二环节：“职业世界探索”专题展示。选手以“职业认知”为专题，结合《职场角色模拟》VCR进行PPT陈述。专家现场打分，成绩前15名的选手进入到第三环节主题答辩。
                            第三环节：“大学生职业生涯规划”自我展示及答辩。选手以“大学生职业生涯规划”为主题进行演讲，限时6分钟，现场答辩限时2分钟。根据选手表现，评委打分，决出奖项。
                            此赛段最终内容将根据疫情情况进行调整，请各高校充分重视，积极组织学生和指导教师筹备决赛，具体事宜另行通知。
                        </p>
                    </div>
                </li>

            </ul>
        </div>
    </div> -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  //加密
  import {getTokenUrl} from "@/api/uploading";
  // 引入插件
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import {
    getHomeData,
    getSchoolData,
    getTimerShaft,
    getTimer,
    getMatchVideo,
    downName,
  } from "../api/home";
  import {getDomain, isDuringDate,getFormal} from "@/utils/toos";
  import {Session} from "@/utils/storage";
  import {getData} from "@/api/notice";
  import BScroll from "better-scroll";

  export default {
    components: {
      swiper,
      swiperSlide,
    },
    data() {
      return {
        dataList: {},
        banner: [],
        swiperOption: {
          circular: true,
          // notNextTick:true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },

          // 显示分页
          pagination: {
            el: ".swiper-pagination",
            clickable: true, //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        params: {
          domain: "",
          //   id:14
        },
        competingKits: {
          loop: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          // 显示分页
          pagination: {
            el: ".swiper-pagination1",
            clickable: true, //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          slidesPerView: 3, //一行显示3个
          slidesPerColumn: 2, //显示2行
        },
        matchId: "",
        showSelf: "",
        clickIndex: null,
        objnews: [],
        newsparams: {
          page: 1,
          limit: 4,
          matchId: "",
          orderRule: "create_time",
        },
        newsDataList: [],
        schoollogoImg: [],
        imgUrl: "http://wlzj2.test.upcdn.net",
        timerShaft: [],
        dialogVisible: false,
        schooltop: false,
        systime: "",
        timeactive: null,
        video: "",
        videoList: [],
        myurl:
          "https://wlzj-platform.posedu.com.cn/manage/uploads/20211031/lmnhax420018fngepwkubpv3jwbg7nx8.jpg",
        goods: [
          {name: "dasda"},
          {name: "dasda"},
          {name: "dasda"},
          {name: "dasda"},
          {name: "dasda"},
          {name: "dasda"},
          {name: "dasda"},
          {name: "dasda"},
        ],
      };
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      },
    },
    created() {
      //   this.$store.dispatch("setProcess", 100);
      //   console.log('vuex1111111111111',this.$store);
      getDomain();

      this.params.domain = Session.get("domain");
      getHomeData(this.params).then((res) => {
        if (!this.params.domain || res.data.data==null) {
          this.$router.push("/nomatch");
        }
        if(!res.data.data){
          console.log("获取数据失败");
          return ;
        }
        this.newsparams.matchId = res.data.data.id;
        getData(this.newsparams).then((res) => {
          this.newsDataList = res.data.data.list;
          getTimerShaft({matchId: this.newsparams.matchId}).then((res) => {
            //   console.log("赛段进程",res)
            this.timerShaft = res.data.data;
            this.timerShaft.forEach((item) => {
              item.matchTime = item.matchTime.replace(",", "至");
            });
            let arr = [];
            res.data.data.forEach((item) => {
              arr.push(item.matchTime.split(","));
            });
            arr.forEach((item, index) => {
              if (isDuringDate(this.systime, item[0], item[1])) {
                this.timeactive = index;
              }
            });
          });
        });

        // 存储 domain 到浏览器缓存
        // this.matchLogo =res.data.data.matchLogo
        // this.matchName =res.data.data.matchName
        // document.title = res.data.data.matchName
        Session.set("matchID", this.matchId);
        getMatchVideo({matchId: this.newsparams.matchId}).then((res) => {
          if(!res.data.data || res.data.data.length<1){
            return false;
          }
          var url = res.data.data[0].url;
          if (!url) {
            return false;
          }
          this.videoList = JSON.parse();
          this.videoList.forEach((item) => {
            item.name = item.name.replace(".mp4", "");
          });
        });
        //   Session.set('matchLogo',this.matchLogo)
      });

      //  this.getListData()
    },
    mounted() {
      getTimer().then((res) => {
        this.systime = res.data.data;
      });
      this.getListData();
      this.newsparams.matchId = Session.get("matchID");

      //  this.showSelf =  Session.get('token')
      //  console.log(this.showSelf)
      // current swiper instance
      // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了

      // this.swiper.slideTo(3, 1000, false);
      if (this.$route.query.mao == 1) {
        let selector = "#download";
        var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id,是(#id)
        document.body.scrollTop = anchor.offsetTop; // chrome
        document.documentElement.scrollTop = anchor.offsetTop; // firefox
      }
    },
    methods: {
      getListData() {
        let domain = Session.get("domain");
        let matchID = Session.get("matchID");
        this.params.domain = domain;
        getHomeData(this.params).then((res) => {
          if(res.data.data == null){
            this.$router.push("/nomatch");
          }
          this.matchId = res.data.data.id;
          // 存储 domain 到浏览器缓存
          Session.set("matchID", this.matchId);
          Session.set("ifStudent", res.data.data.ifStudent);
          Session.set("ifHasItem", res.data.data.ifHasItem);

          this.dataList = res.data.data;
          let objbanner = [];
          if(this.dataList.banner){
            objbanner = JSON.parse(this.dataList.banner);
          }
          let objnews = [];
          if(this.dataList.attachment){
            objnews = JSON.parse(this.dataList.attachment);
          }
          let newbanner = [];
          if (objbanner) {
            objbanner.forEach((item) => newbanner.push(item.url));
            var b = 0;
            var lastbanner = [];
            for (var a = 0; a < newbanner.length; a++) {
              getTokenUrl(newbanner[a]).then((res) => {
                lastbanner[b] = res.data;
                b++
              });
            }
          }
          this.objnews = objnews;
          this.banner = lastbanner;
          if (!this.dataList.showVideo) {
            return false;
          }
          if (JSON.parse(this.dataList.showVideo).length > 0) {
            var lastvideo = "";
            lastvideo = JSON.parse(this.dataList.showVideo)[0].url;
            getTokenUrl(lastvideo).then((res) => {
              this.video = res.data;
            });

          }
          //   console.log("objnews",this.objnews)
        }),
          //   getTimerShaft({matchId:matchID}).then(res=>{
          //     //   console.log("赛段进程",res)
          //       this.timerShaft = res.data.data
          //       let arr = []
          //       res.data.data.forEach(item =>{
          //           arr.push(item.matchTime.split(","))
          //       })
          //       console.log("matvhtime",arr);
          //       arr.forEach((item,index) =>{
          //           console.log("item[0]",item[0],item[1]);
          //          if(isDuringDate(this.systime,item[0],item[1])){
          //              console.log("itwmindex",index);
          //              this.timeactive = index
          //          }
          //       })
          //   })
          getSchoolData({domain: domain}).then((res) => {
            let schoolImg = res.data.data;
            if(!schoolImg){
              return;
            }
            schoolImg.forEach((item) => {
              if (item.logo && item.logo.search("http") == -1) {
                let imgurl = this.imgUrl + item.logo;
                this.schoollogoImg.push(imgurl);
              } else if (item.logo) {
                this.schoollogoImg.push(item.logo);
              }
              //   console.log(this.schoollogoImg)
            });
          });
      },
      toinfo(e) {
        this.$router.push({path: "/noticInfo", query: {id: e}});
      },
      showShaft(e) {
        this.dialogVisible = true;
      },
      scrollFunc(e) {
        let scroll = document.documentElement.scrollTop;
      },
      getMatchId() {
        getDomain();
        getHomeData({domian: Session.get("domain")}).then((res) => {
          if (!this.params.domain || res.data.data==null) {
            this.$router.push("/nomatch");
          }
          this.matchId = res.data.data.id;
          // 存储 domain 到浏览器缓存
          this.matchLogo = res.data.data.matchLogo;
          this.matchName = res.data.data.matchName;
          document.title = res.data.data.matchName;
          Session.set("matchID", this.matchId);
          Session.set("matchLogo", this.matchLogo);

          getData(this.newsparams).then((res) => {
            this.newsDataList = res.data.data.list;
          });
        });
      },
      chooseClick(e) {
        if (this.clickIndex == e) {
          this.clickIndex = null;
        } else {
          this.clickIndex = e;
        }
      },
      vidPP() {
        var videos = document.getElementsByTagName("video"); //获取所有video
        for (var j = videos.length - 1; j >= 0; j--) {
          videos[j].pause();
        }
      },
      downName(filePath, fileName) {
        // console.log(`https://api.match.posedu.com.cn/support/download/download?filePath=${filePath}&fileName=${encodeURI(fileName)}`);
        window.open(
          `${getFormal()}/support/download/downloadencoder?filePath=${filePath}&fileName=${fileName}`
        );
      },
    },
  };
</script>

<style scoped>
  .banner .slideBox .bd img {
    width: 100%;
    display: block;
  }

  .banner {
    width: 99vw;
    margin: 0 auto;
    overflow: hidden;
  }

  .banner .slideBox {
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .banner .slideBox .bd {
    position: relative;
    height: 100%;
    z-index: 0;
  }

  .banner .slideBox .bd ul {
    width: 100%;
    margin: 0;
  }

  .banner .slideBox .bd li {
    zoom: 1;
    vertical-align: middle;
  }

  .bd ul {
    padding: 0;
  }

  p.introbro {
    padding-top: 108px;
    margin-top: -108px;
    /* z-index: 99999;
      position: absolute;
     left: 50%;
      transform: translateX(-50%); */
  }

  .news p:hover {
    color: #315efb;
  }

  .comp_related {
    /* background: #fef0cd; */
    padding-bottom: 50px;
  }

  .comp_related_title {
    background: url(http://jlcareer.match.posedu.cn/assets/addons/cms/img/ctitle_03_dark.png) center no-repeat;
  }

  .EventSchedule {
    margin-bottom: 50px;
  }

  .comp_related_sect ul {
    background: #fff;
    padding-left: 0px;
  }

  .comp_related_sect li {
    border: 1px solid #d8d8d8;
    overflow: hidden;
  }

  .comp_related_sect li .cr_l {
    min-height: 204px;
    border-right: 1px solid #d8d8d8;
  }

  .comp_related_sect li div {
    width: 49.7%;
    float: left;
    padding: 30px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-left: 1px solid #d8d8d8;
    margin-left: -1px;
  }

  .cr_l img,
  .cr_r img {
    padding-right: 11px;
  }

  .sect_title {
    padding-bottom: 40px;
    height: 140px;
  }

  .cr_title {
    font-size: 22px;
    line-height: 50px;
    padding-left: 0px;
  }

  .cr_det {
    padding-left: 58px;
    line-height: 18px;
  }

  /* .comp_related_sect li:last-child {
      border-bottom: none;
  } */
  .sche_arrange_title {
    background: url(http://jlcareer.match.posedu.cn/assets/addons/cms/img/ctitle_04.png) center no-repeat;
  }

  /deep/ .el-steps.container.computer.el-steps--horizontal {
    margin-top: 38px;
  }

  .sche_arrange_sect > ul,
  .sche_arrange_sect > ul > li {
    height: 800px;
  }

  .sche_arrange_sect > ul > li {
    border-bottom: 3px solid #0e3e86;
  }

  .competition_news_sect li,
  .sche_arrange_sect > ul > li {
    float: left;
    width: 33.3%;
    box-sizing: border-box;
    border-right: 1px solid #ececec;
  }

  .competition_news_sect .cn_top,
  .sche_arrange_sect .cn_top {
    background: #f1f1f1;
    font-family: "Arial";
    color: #999;
    text-indent: 30px;
  }

  p.cr_det a {
    width: 100%;
    margin-bottom: 6px;
  }

  a {
    color: #00baff !important;
  }

  .competition_news_sect .cn_top .cn_year,
  .sche_arrange_sect .cn_top .cn_year {
    display: block;
    padding-top: 15px;
  }

  .fsize18 {
    font-size: 18px;
  }

  .competition_news_sect .cn_top .cn_date,
  .sche_arrange_sect .cn_top .cn_date {
    font-size: 50px;
    line-height: 68px;
    display: block;
  }

  .sche_arrange_sect > ul > li .sa_explain {
    margin: 50px 30px 0;
    line-height: 24px;
  }

  ul li {
    list-style: none;
  }

  .swiper-container {
    position: relative;
    width: 100%;
    /* height: 686px; */
    background: #fff;
  }

  .swiper-container .swiper-slide {
    width: 100%;
    line-height: 200px;
    /* background: yellowgreen; */
    color: #000;
    font-size: 16px;
    text-align: center;
    width: 100%;
    height: 0;
    position: relative;
    padding-top: 37%;
  }

  .homehot {
    display: flex;
    margin: 0 auto;
    padding-top: 15px;
    padding-bottom: 15px;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .homehot .title {
    font-size: 20px;
    width: 70px;
    background-color: #00baff;
    color: #fff;
    text-align: center;
    padding: 6px;
    border-radius: 6px;
    height: 70px;
    font-weight: 600;
  }

  .news {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }

  .news > div {
    width: 50%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    letter-spacing: 1px;
  }

  .matchIntroduced .title {
    text-align: center;
    font-size: 26px;
    color: #00baff;
    font-weight: 600;
  }

  .comp_related .title,
  .competingKits .title {
    text-align: center;
    font-size: 26px;
    color: #00baff;
    font-weight: 600;
    margin: 15px 0;
  }

  .ParticipatingSchools .title {
    text-align: center;
    font-size: 26px;
    color: #00baff;
    font-weight: 600;
    margin: 15px 0;
  }

  .EventSchedule {
    min-height: 172px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #00baff;
  }

  /deep/ .el-step__description.is-finish,
  /deep/ .el-step__title.is-finish {
    color: #fff !important;
  }

  /deep/ .el-step__head.is-finish {
    border-color: #fff !important;
  }

  .competingKits .swiper-wrapper > div {
    height: 50%;
  }

  #slideBox img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
  }

  /deep/ .el-step__icon-inner {
    display: none;
  }

  /* .EventSchedule.container:hover{
    display: none;
  } */

  .titleasdas {
    text-align: center;
    font-size: 26px;
    color: #00baff;
    font-weight: 600;
    margin: 15px 0;
  }

  .intro {
    display: none;
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    width: 475px;
    /* width: 60%; */
    border: 1px solid #fff;
    background-color: #fff;
    padding: 5px;
    max-height: 400px;
    overflow-y: scroll;
    border: 1px solid #ccc;
    z-index: 9999999;
  }

  .el-step__head:hover + .el-step__main .intro,
  .el-step__title:hover + .el-step__description .intro,
  .el-step__main:hover .intro {
    display: block;
    border-radius: 5px;
    box-shadow: 3px 3px 2px #888888;
    cursor: pointer;
  }

  /deep/ .el-step__main:hover .intro {
    display: block;
    border-radius: 5px;
    box-shadow: 3px 3px 2px #888888;
    cursor: pointer;
  }

  /deep/ .el-step__main {
    cursor: pointer;
  }

  .intro p {
    font-size: 15px;
    letter-spacing: 1px;
    color: black;
    text-align: initial;
  }

  /deep/ .el-step__title.is-process {
    color: yellow;
  }

  /deep/ .is-process .el-step__icon.is-text {
    border-color: yellow !important;
    background-color: yellow;
  }

  /deep/ .el-step__description.is-process {
    color: yellow !important;
  }

  /deep/ .el-step__line {
    background-color: #fff;
  }

  .schoolP {
    max-height: 600px;
    overflow-y: scroll;
    padding: 9px !important;
  }

  p.introbro {
    font-size: 14px;
  }

  /deep/ .el-step__description.is-wait,
  /deep/ .el-step__title.is-wait {
    color: #fff;
  }

  /deep/ .el-step.is-center .el-step__description {
    padding-top: 46px;
  }

  /deep/ .el-step__title {
    margin-top: -73px;
    font-size: 18px;
  }

  .wrapper {
    display: none;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  video {
    width: 100%;
    height: 81%;
  }

  /deep/ .el-carousel.el-carousel--horizontal.el-carousel--card h2 {
    text-align: center;
    background-color: #fff;
    padding-top: 24px;
    margin-top: -16px;
    padding-bottom: 22px;
    margin-bottom: -10px;
    font-size: 22px;
  }

  /deep/ .el-carousel__item {
    /* height: 79% !important; */
    /* overflow: auto !important; */
    /* width: 40%; */
  }

  .pcmobile {
    display: none;
  }

  /* 移动端样式 */
  @media screen and (max-width: 900px) {
    .pcmobile {
      display: block;
    }

    .pc {
      display: none;
    }

    .comp_related_sect li div {
      width: 100%;
    }

    .schoolP {
      height: 500px;
      overflow-y: scroll;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
    }

    .schoolP > img {
      width: 65px !important;
      height: 65px !important;
    }

    .container {
      width: auto !important;
    }

    video.homehot.container {
      width: 100vw !important;
    }

    .homehot .title {
      display: none;
    }

    .comp_related_sect li {
      border: none !important;
    }

    .comp_related_sect li div {
      padding-bottom: 0 !important;
    }

    .comp_related_sect li .cr_l {
      min-height: 0;
    }

    .news > div {
      width: 84vw;
    }

    .news > div > p {
      max-width: 70% !important;
    }

    .news > div > span {
      font-size: 12px;
    }

    .swiper-wrapper {
      height: 43%;
    }

    .swiper-container {
      height: 203px;
    }

    .haacf {
      margin-top: 106px !important;
    }

    /* .el-step:last-child .el-step__head:hover + .el-step__main  .intro{
      left: -160px !important;
  } */
    .intro {
      /* display: none; */
      position: absolute;
      top: 100px;
      left: 36%;
      width: 475px;
      /* width: 60%; */
      border: 1px solid #fff;
      background-color: #fff;
      padding: 5px;
    }

    .intro {
      display: none;
      /* position: fixed; */
      width: 73vw !important;
      top: 28px !important;
      left: 156px !important;
      z-index: 9999;
    }

    /deep/ .el-step {
      position: relative;
    }

    /deep/ .el-steps.container.el-steps--horizontal {
      position: relative;
    }

    /deep/ .el-step__description.is-wait,
    /deep/ .el-step__title.is-wait {
      color: #fff;
    }

    .wrapper {
      display: block;
      width: 100%;
      height: 100%;
      /* overflow-x: hidden;
          overflow-y: visible;
          padding: 500px 0;
          margin: -500px 0;  */
    }

    /deep/ .el-steps--vertical {
      padding: 20px;
      padding-left: 31px;
      padding-bottom: 0px;
    }

    /deep/ .el-step__icon {
      width: 18px;
      height: 18px;
    }

    .el-step__head:hover + .el-step__main .intro,
    .el-step__title:hover + .el-step__description .intro {
      display: block;
      border-radius: 5px;
      box-shadow: 3px 3px 2px #888888;
    }

    p.introbro {
      width: 229px;
      margin-bottom: 28px;
      font-size: 15px;
      letter-spacing: 2px;
    }

    /deep/ .el-step.is-vertical .el-step__line {
      left: 8px;
    }

    /deep/ .el-step__title {
      margin-top: 0;
    }

    .content {
      margin-top: 50px;
      white-space: nowrap;
    }

    .item {
      float: left;
      width: 60px;
    }

    .computer {
      display: none;
    }

    .comp_related_sect li .cr_l {
      border-right: none !important;
    }

    /deep/ .el-step__description {
      pointer-events: none;
    }

    .titleasdas {
      display: none;
    }

    .sadadfc {
      width: auto !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue